// アラート
export const ALERT_SHOW = 'ALERT_SHOW';
export const ALERT_CLOSE = 'ALERT_CLOSE';

// ローディング
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';

// マイページログイン
export const MYPAGE_LOGIN_REQUEST = 'MYPAGE_LOGIN_REQUEST';
export const MYPAGE_LOGIN_REQUEST_SUCCESS = 'MYPAGE_LOGIN_REQUEST_SUCCESS';
export const MYPAGE_LOGIN_REQUEST_FAIL = 'MYPAGE_LOGIN_REQUEST_FAIL';

// マイページ履歴
export const MYPAGE_HISTORY_REQUEST = 'MYPAGE_HISTORY_REQUEST';
export const MYPAGE_HISTORY_REQUEST_SUCCESS = 'MYPAGE_HISTORY_REQUEST_SUCCESS';
export const MYPAGE_HISTORY_REQUEST_FAIL = 'MYPAGE_HISTORY_REQUEST_FAIL';

// 領収書
export const MYPAGE_RECEIPT_REQUEST = 'MYPAGE_RECEIPT_REQUEST';
export const MYPAGE_RECEIPT_REQUEST_SUCCESS = 'MYPAGE_RECEIPT_REQUEST_SUCCESS';
export const MYPAGE_RECEIPT_REQUEST_FAIL = 'MYPAGE_RECEIPT_REQUEST_FAIL';

// 注文マスタデータ取得
export const ORDER_MASTER_REQUEST = 'ORDER_MASTER_REQUEST';
export const ORDER_MASTER_REQUEST_SUCCESS = 'ORDER_MASTER_REQUEST_SUCCESS';
export const ORDER_MASTER_REQUEST_FAIL = 'ORDER_MASTER_REQUEST_FAIL';

// 住所取得
export const YGETS_ADDRESS_REQUEST = 'YGETS_ADDRESS_REQUEST';
export const YGETS_ADDRESS_REQUEST_SUCCESS = 'YGETS_ADDRESS_REQUEST_SUCCESS';
export const YGETS_ADDRESS_REQUEST_FAIL = 'YGETS_ADDRESS_REQUEST_FAIL';

// 注文記録
export const ORDER_AGGREGATORS_REQUEST = 'ORDER_AGGREGATORS_REQUEST';
export const ORDER_AGGREGATORS_REQUEST_SUCCESS =
  'ORDER_AGGREGATORS_REQUEST_SUCCESS';
export const ORDER_AGGREGATORS_REQUEST_FAIL = 'ORDER_AGGREGATORS_REQUEST_FAIL';

export const ORDER_AGGREGATORS_REQUEST_ERROR_MESSAGE = 'ORDER_AGGREGATORS_REQUEST_ERROR_MESSAGE';

// 注文記録（銀行振込）
export const ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST =
  'ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST';
export const ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_SUCCESS =
  'ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_SUCCESS';
export const ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_FAIL =
  'ORDER_AGGREGATORS_BANK_TRANSFER_REQUEST_FAIL';

// 見積書
export const ORDER_AGGREGATORS_QUOTATION_REQUEST =
  'ORDER_AGGREGATORS_QUOTATION_REQUEST';
export const ORDER_AGGREGATORS_QUOTATION_REQUEST_SUCCESS =
  'ORDER_AGGREGATORS_QUOTATION_REQUEST_SUCCESS';
export const ORDER_AGGREGATORS_QUOTATION_REQUEST_FAIL =
  'ORDER_AGGREGATORS_QUOTATION_REQUEST_FAIL';

// お問い合わせ
export const CONTACT_REQUEST = 'CONTACT_REQUEST';
export const CONTACT_REQUEST_SUCCESS = 'CONTACT_REQUEST_SUCCESS';
export const CONTACT_REQUEST_FAIL = 'CONTACT_REQUEST_FAIL';



// WEBPACK FOOTER //
// ./src/constants/action-types.js